import React from 'react';
import { useNavigate } from "react-router-dom";
import "../../styles/support/support_us.css";

const SupportUs = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    return(
        <div className="support_us_screen">
            <div className="contact_us_screen_header_con">
                <p className="contact_us_screen_header">Support Movinity</p>
                <p onClick={goBack} className="home_view_discussions_back">back</p>
            </div>

            <div className="contact_us_screen_divider"></div>

            <p className="support_us_screen">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's 
                standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a 
                type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining 
                essentially unchanged
            </p>

            <div>
                Bank
            </div>
        </div>
    );
};

export default SupportUs;